<script setup lang="ts">
import { useOpenCardCustomisation } from './composables/useConversationsCustomisation';
import ConversationsList from './components/ConversationsList.vue';
import { useOpenConversations } from '@/common/api/conversations.api';
import { useBotUser } from '@/stores/useBotUser';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const cardCustomisation = useOpenCardCustomisation();
const { user, guestUser } = storeToRefs(useBotUser());
const requesterId = computed(() => user.value.id || guestUser.value?.id || '');
</script>

<template>
  <ConversationsList
    title="Open Conversations"
    :requester-id="requesterId"
    :query-hook="useOpenConversations"
    :customisation="cardCustomisation"
    :no-tag="true"
    page-query-key="openPage"
  />
</template>
